import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { getAuthorizationHeaderByUrl } from '../auth';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
    public constructor(private url: string) {
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let authReq: HttpRequest<any> = req;
        if (!(new RegExp(this.url.split( ',').join('$|') + '$').test(req.url))) {
            // Get the auth header from the service.
            const authHeaderName = 'Authorization';
            // Clone the request to add the new header.
            authReq = req.clone({
                headers: req.headers.set(authHeaderName, getAuthorizationHeaderByUrl(req.url))
            });
        }
        // Pass on the cloned request instead of the original request.
        return next.handle(authReq).pipe(
            tap(() => {
                // if (event instanceof HttpResponse) {
                //     // do stuff with response if you want
                // }
            }, error => {
                // Remember, there may be other events besides just the response.
                if (error instanceof HttpErrorResponse) {
                    if (error.status === 401) {
                        console.log('ç»éè¿æ');
                    }
                }
                return;
            })
        );
    }
}
